<template>
  <div>
    <Title></Title>
    <p class="tv" style="color: white">素材</p>
  </div>
</template>

<script>
import Title from "../../components/title.vue";

export default {
  name: "SourcePage",
  components: {Title}
}
</script>

<style scoped>

.tv {
  margin-top: 20px;
  margin-bottom: 20px;
  padding: 20px;
  border: 1px solid white;
}

</style>



// WEBPACK FOOTER //
// src/views/source_page/SourcePage.vue